import { FullBoatSearchDetail } from '../types/api/v4/boats/search';

/**
 * Finds the boat with matching `id` and returns the `property` of the boat
 * @param boats The array of boats to look up
 * @param id the id of the boat to retrieve the property from
 * @param property key of a boat to return
 * @returns the `property` of the boat with match `id` or null
*/
function getBoatProperty<T extends Partial<FullBoatSearchDetail>, K extends keyof T>(
  boats: T[],
  id: T['id'],
  property: K,
): T[K] | null {
  const foundBoat = boats.find((boat) => boat.id === id);
  return foundBoat?.[property] ?? null;
}

export default getBoatProperty;
